import type { Station } from "@station/domain/models/station.model";
import type { StationRepository } from "@station/domain/repositories/station.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";
import type { Observable } from "rxjs";

@injectable()
export class StationGetSelectedUseCase {
    constructor(
        @inject(stationsTypes.repositories.StationRepository)
        private readonly stationRepository: StationRepository,
    ) {}

    execute(): Observable<readonly Readonly<Station>[]> {
        return this.stationRepository.selectedStations;
    }
}
